var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.03 39.57"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 39.57a1 1 0 01-.62-.22 1 1 0 01-.16-1.41l14.53-18.16L.22 1.62A1 1 0 01.38.22a1 1 0 011.4.16l15 18.78a1 1 0 010 1.25l-15 18.78a1 1 0 01-.78.38z",
    "data-name": "Layer 1"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNy4wMyAzOS41NyI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBkPSJNMSwzOS41N2ExLDEsMCwwLDEtLjYyLS4yMiwxLDEsMCwwLDEtLjE2LTEuNDFMMTQuNzUsMTkuNzguMjIsMS42MkExLDEsMCwwLDEsLjM4LjIyYTEsMSwwLDAsMSwxLjQuMTZsMTUsMTguNzhhMSwxLDAsMCwxLDAsMS4yNWwtMTUsMTguNzhBMSwxLDAsMCwxLDEsMzkuNTdaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgChevronRight as ReactComponent };